/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Tier_OnlyInputs */

const en_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Tier Only`)
};

const es_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo nivel Sovereign`)
};

const fr_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau Sovereign uniquement`)
};

const de_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Sovereign-Stufe`)
};

const ja_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign ティアのみ`)
};

const zh_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限 Sovereign 级别可用`)
};

const ar_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستوى Sovereign فقط`)
};

const id_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya Paket Sovereign`)
};

const it_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo Livello Sovereign`)
};

const ru_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только на тарифе Sovereign`)
};

const pt_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente Plano Sovereign`)
};

const ko_sovereign_tier_only = /** @type {(inputs: Sovereign_Tier_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 등급 전용`)
};

/**
* | output |
* | --- |
* | "Sovereign Tier Only" |
*
* @param {Sovereign_Tier_OnlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_tier_only = /** @type {((inputs?: Sovereign_Tier_OnlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Tier_OnlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_tier_only(inputs)
	if (locale === "es") return es_sovereign_tier_only(inputs)
	if (locale === "fr") return fr_sovereign_tier_only(inputs)
	if (locale === "de") return de_sovereign_tier_only(inputs)
	if (locale === "ja") return ja_sovereign_tier_only(inputs)
	if (locale === "zh") return zh_sovereign_tier_only(inputs)
	if (locale === "ar") return ar_sovereign_tier_only(inputs)
	if (locale === "id") return id_sovereign_tier_only(inputs)
	if (locale === "it") return it_sovereign_tier_only(inputs)
	if (locale === "ru") return ru_sovereign_tier_only(inputs)
	if (locale === "pt") return pt_sovereign_tier_only(inputs)
	return ko_sovereign_tier_only(inputs)
});